import { ref, computed } from "vue"

const subscriptionCancelled = ref(
    sessionStorage.getItem("isSubscriptionCancelled") === "true"
)

export const useSubscriptionStatus = () => {
    const isSubscriptionCancelled = computed(() => subscriptionCancelled.value)

    const syncSubscriptionStatusToSession = (status: String) => {
        const isCancelled = status === "cancelled"
        sessionStorage.setItem(
            "isSubscriptionCancelled",
            isCancelled.toString()
        )
        subscriptionCancelled.value = isCancelled
    }

    return {
        isSubscriptionCancelled,
        syncSubscriptionStatusToSession,
    }
}
